import React, { useEffect, useRef, useState } from 'react';
import {
	MenuIcon,
	NotificationIcon,
	TasksIcon
} from 'ui-component/custom-icons/icons';
import { Avatar } from '@mui/material';
import Sidebar from '../Sidebar';
import { useDispatch, useSelector } from 'react-redux';
import { setLogout, storeHasNewNotification } from 'store/reducers/mainSlice';
import { Link } from 'react-router-dom';
import NotificationDropdown from 'ui-component/NotificationDropdown/NotificationDropdown';
import ProfileMenuBlock from 'ui-component/ProfileMenuBlock';

const NavMobile = () => {
	const userIconRef = useRef(null);
	const [showMenu, setShowMenu] = useState(false);
	const [showNotifications, setShowNotifications] = useState(false);

	const hasNewNotification = useSelector((state) => state.main?.hasNewNotification);
	const profilePhoto = useSelector((state) => state.main?.user?.profile_photo_url);

	const dispatch = useDispatch();

	const [showProfileMenu, setShowProfileMenu] = useState(false);

	const handleMenuButton = () => {
		setShowNotifications(false);
		setShowMenu(!showMenu);
	};

	const handleCloseMenuButton = () => {
		setShowMenu(false);
	};

	useEffect(() => {
		api.userHasUnreadNotification().then((res) => {
			if (res.status) {
				dispatch(storeHasNewNotification(res?.data?.has_unread));
			}
		});
	}, []);

	const handleShowNotification = () => {
		setShowMenu(false);
		setShowNotifications(!showNotifications);
	};

	return (
		<>
		
			{showProfileMenu && (
				<div
					style={{
						position: 'fixed',
						top: 0,
						left: 0,
						width: '100vw',
						height: '100dvh',
						zIndex: 9, // Make sure this is below your menu's z-index
						backdropFilter: 'blur(8px)',
						WebkitBackdropFilter: 'blur(8px)',
						background: 'rgba(0,0,0,0.1)' // Optional: slight dark overlay
					}}
					onClick={() => {
						setShowProfileMenu(false);
					}}
				/>
			)}
			<div className={`navMobileMenu ${showMenu ? 'show-mobile' : ''}`}>
				<Sidebar mobile mobileShowMenu={showMenu} closeMobileMenu={handleCloseMenuButton} />
			</div>
			<div className="navMobile" >
				<div className="action-item">
					<span onClick={handleMenuButton}>
						<MenuIcon width={24} height={24} />
					</span>
				</div>
				<div className="action-item">
					<span className="icon-noti" onClick={handleShowNotification}>
						<NotificationIcon width={24} height={24} />
						{/* {hasNewNotification && <span className="badge badge-danger badge-counter noti-badge">&nbsp;</span>} */}
					</span>
					{showNotifications && (
						<div className="mobile-noti-view">
							<NotificationDropdown
								closeNotificationBox={() => {
									setShowNotifications(false);
								}}
							/>
						</div>
					)}
				</div>
				
				<div className="action-item">
					<TasksIcon width={24} height={24} />
				</div>
				<div className="action-item" >
					<div
						className="user-icon-item"
						onClick={() => {
							setShowProfileMenu(!showProfileMenu);
						}}
						ref={userIconRef}
					>
						<Avatar
							sx={{ width: 30, height: 30 }}
							src={profilePhoto ? profilePhoto : 'https://cdn.iconscout.com/icon/free/png-256/free-avatar-380-456332.png'}
						/>
					</div>
					{showProfileMenu && (
						<ProfileMenuBlock
							onCloseMenu={() => {
								setShowProfileMenu(false);
							}}
							mainIconRef={userIconRef}
							mobile
						/>
					)}
				
				</div>
			</div>
		</>
	);
};

export default NavMobile;

const CustomToggle = React.forwardRef(({ children, onClick }, ref) => {
	return (
		<>
			<Link
				className="nav-link dropdown-toggle "
				to="#"
				id="userDropdown"
				role="button"
				data-toggle="dropdown"
				aria-haspopup="true"
				aria-expanded="false"
				onClick={onClick}
			>
				{children}
			</Link>
		</>
	);
});
